import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=68e00f5a&scoped=true"
import script from "./ClientInfo.vue?vue&type=script&lang=js"
export * from "./ClientInfo.vue?vue&type=script&lang=js"
import style0 from "./ClientInfo.vue?vue&type=style&index=0&id=68e00f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e00f5a",
  null
  
)

export default component.exports